import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    marginHorizontal: 16,
    marginTop: 10,
  },
  quickActionMenuContainerStyle: {
    paddingHorizontal: 0,
  },
  currentAccountTitleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24.9,
    color: theme.colors.headerTitleColor,
    marginBottom: 33,
  }),
  otherAccountsTitleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 24.9,
    color: theme.colors.headerTitleColor,
    marginVertical: 33,
  }),
  accountItemContainerStyle: theme => ({
    borderTopWidth: 1,
    borderTopColor: theme.colors.divider,
  }),
  cancelButtonStyle: theme => ({
    marginTop: 32,
    borderColor: theme.colors.borderColorFive,
  }),
});
